import { ApplicationPartner, ApplicationPartnerTypeEnum, ApplicationUser } from '@tran-monorepo/interfaces';

export function cleanUserObject(user: ApplicationUser): Omit<ApplicationUser, 'createdAt' | 'updatedAt'> {
    return {
        gid: user.gid,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        orgCode: user.orgCode
    };
}

export function mapApplicationUserToPartner(
    applicationUsers: ApplicationUser[],
    partnerType: ApplicationPartnerTypeEnum
): ApplicationPartner[] {
    return applicationUsers
        .map(user => cleanUserObject(user))
        .map(user => ({
            ...user,
            partnerType
        }));
}
